module.exports = __webpack_public_path__ + "static/media/CeraPro-Light.67dbc6c4.woff";